<template>
  <div class="webinar-chat-panel">
    <ChatTabs
      :active-tab="activeTab"
      :unread-counts="unreadCounts"
      :is-organizer="isOrganizer"
      @update:active-tab="setActiveTab"
    />

    <div class="webinar-chat-panel__body">
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
        height="2"
        class="webinar-chat-panel__loader"
      />

      <OrganizerChatTab
        v-if="isOrganizer"
        v-show="activeTab === 'organizer'"
        :current-user-id="currentUserId"
        :role-map="roleMap"
      />
      <PrivateChatTab
        v-show="activeTab === 'private'"
        :is-moderator="isOrganizer"
        :current-user-id="currentUserId"
      />
      <PollsTab
        v-show="activeTab === 'polls'"
        :is-moderator="isOrganizer"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import ChatTabs from './ChatTabs.vue';
import OrganizerChatTab from './OrganizerChatTab.vue';
import PrivateChatTab from './PrivateChatTab.vue';
import PollsTab from './PollsTab.vue';

export default {
  name: 'WebinarChatPanel',

  components: { ChatTabs, OrganizerChatTab, PrivateChatTab, PollsTab },

  props: {
    webinarId: {
      type: Number,
      required: true,
    },
    moderatorId: {
      type: Number,
      default: null,
    },
    hostId: {
      type: Number,
      default: null,
    },
    panelistIds: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapGetters('webinarChat', ['activeTab', 'unreadCounts', 'isLoading']),

    currentUserId() {
      const id = window.DJANGO_REQUEST?.user?.id;
      return id ? Number(id) : null;
    },

    isOrganizer() {
      const djangoUser = window.DJANGO_REQUEST?.user;
      if (!djangoUser) return false;
      const { id, is_superuser } = djangoUser;
      return is_superuser
        || id === this.moderatorId
        || id === this.hostId
        || this.panelistIds.includes(id);
    },

    // Maps userId (number) → role label for rendering in the organizer chat
    roleMap() {
      const map = {};
      if (this.hostId) map[this.hostId] = 'Host';
      if (this.moderatorId) map[this.moderatorId] = 'Moderator';
      this.panelistIds.forEach((id) => {
        if (!map[id]) map[id] = 'Panelist';
      });
      return map;
    },
  },

  created() {
    this.initChat({ webinarId: this.webinarId, isOrganizer: this.isOrganizer });
    if (this.isOrganizer) {
      this.setActiveTab('organizer');
    }
  },

  beforeDestroy() {
    this.destroyChat();
  },

  methods: {
    ...mapActions('webinarChat', ['initChat', 'destroyChat']),
    ...mapMutations('webinarChat', ['setActiveTab']),
  },
};
</script>

<style lang="scss" scoped>
.webinar-chat-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
  border-left: 1px solid rgba(0, 0, 0, 0.08);

  &__body {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
  }

  &__loader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
  }
}
</style>
